import type { Bed } from './beds'
import { customGeometry, customStyle, type BedRect } from './custom-layout.js'
import { bunkJoinery } from './bunk-joinery.js'
import type { BlissRoomFinish } from '../../../../../config/blissRoomFinish'
import type { BedsideSelection } from '../../../../../config/blissBedsideAddons'
import { detailMaterialQuote } from '../../../../../config/blissCustomDetailPricing.js'

export type TrimEdge = 'front'|'back'|'left'|'right'
export function customTrimOmissions(bed:Bed,r:BedRect,upper:boolean):TrimEdge[] {
  const omit:TrimEdge[]=['back']
  if(upper)omit.push(r.axis==='x'?(r.head==='left'?'right':'left'):'front')
  const g=customGeometry(bed)
  for(const other of [g.stairs,g.landing].filter(Boolean)) {
    if(other!.y<r.y+r.h&&other!.y+other!.h>r.y) {
      if(Math.abs(r.x+r.w-other!.x)<0.01)omit.push('right')
      if(Math.abs(r.x-other!.x-other!.w)<0.01)omit.push('left')
    }
  }
  return [...new Set(omit)]
}
export function roomDetailTakeoff(beds:Bed[],finish:BlissRoomFinish,bedDrawers=false,bedside:BedsideSelection[]=[]) {
  // Crown is priced separately by cabinMillworkPricing with the live cost settings.
  const capCuts:number[]=[],quarterCuts:number[]=[]
  let drawers=0,standardDrawersCounted=false
  const add=(w:number,h:number,lower:boolean,omit:TrimEdge[])=>{
    if(!finish.bedTrim||finish.bedTrim==='none')return
    for(const edge of ['front','back','left','right'] as const)if(!omit.includes(edge)) {
      capCuts.push(edge==='front'||edge==='back'?w+(omit.includes('left')?0:0.75)+(omit.includes('right')?0:0.75):h-3.5)
      if(lower&&finish.bedTrim==='cap_quarter_round')quarterCuts.push(edge==='front'||edge==='back'?w:h)
    }
  }
  for(const bed of beds) {
    if(bed.kind==='stairs')continue
    if(bed.kind==='custom'||bed.kind==='bridge') {
      const g=customGeometry(bed)
      for(const r of g.uppers)add(r.w,r.h,false,customTrimOmissions(bed,r,true))
      for(const r of g.lowers)add(r.w,r.h,true,customTrimOmissions(bed,r,false))
      if(customStyle(bed)!=='inlet')drawers+=g.lowers.length*2
    } else {
      const j=bunkJoinery(bed)
      add(j.upper.width,j.frameLength,false,['front'])
      add(j.lower.width,j.frameLength,true,['front'])
      if(bedDrawers&&!standardDrawersCounted){drawers+=2;standardDrawersCounted=true}
    }
  }
  for(const item of bedside)if(item.kind==='nightstand_drawers')drawers+=2*item.quantity
  return {...detailMaterialQuote(capCuts,quarterCuts,finish.drawerPullStyle,drawers,finish.treatment==='unfinished_raw'||['natural_maple','espresso'].includes(finish.frameId)),capCuts,quarterCuts}
}

